// ----------------------------------------------------------------------

// WhatsApp
// ZekiMessage
// SMS
// Infobip

export enum IntegrationCard {
  COMMUNICATION = 'COMMUNICATION',
  E_COMMERCES = 'E_COMMERCES',
  ERP = 'ERP',
}

export const integrationCardLabel = {
  [IntegrationCard.COMMUNICATION]: 'Comunicação',
  [IntegrationCard.E_COMMERCES]: 'E-commerce',
  [IntegrationCard.ERP]: 'ERP',
};

export const integrationCardOptions = [
  {
    label: 'Comunicação',
    value: IntegrationCard.COMMUNICATION,
  },
  {
    label: 'E-commerce',
    value: IntegrationCard.E_COMMERCES,
  },
  {
    label: 'ERP',
    value: IntegrationCard.ERP,
  },
];

export const listCardIntegration = [
  {
    label: 'Tray',
    value: 'tray',
  },
  {
    label: 'Omie',
    value: 'omie',
  },
  {
    label: 'Bling',
    value: 'bling',
  },
  {
    label: 'Whatsapp',
    value: 'whatsapp',
  },
  {
    label: 'Zapi',
    value: 'zapi',
  },
  {
    label: 'Infobip',
    value: 'smsInfobip',
  },
  {
    label: 'Dapic',
    value: 'dapic',
  },
  {
    label: 'Quick ERP',
    value: 'quickErp',
  },
];
